import Layout from "@/components/layout/index.vue";
//权限管理
export default [{
    path: "/",
    name: "personLayout",
    component: Layout,
    meta: {
        title: ""
    },
    children: [{
        path: '/person',
        name: 'person',
        meta: {
            title: "用户管理"
        },
        // component: () => import('@/views/person/userlist'),
    }]
}];